export default "__VITE_ASSET__B$$ekHPM__"